import {
  MenuItem,
  FormHelperText,
  FormControl,
  Select as MuiSelect,
  InputLabel,
} from "@mui/material";

const selectStyles = (theme) => {
  return {
    padding: "0 12px",
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.primary.main,
      paddingLeft: "0px",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
      color: theme.palette.primary.main,
    },
  };
};

const Select = ({
  options = [],
  label,
  value,
  name,
  onChange,
  variant = "standard",
  disabled,
  onBlur,
  error,
  helperText,
}) => {
  return (
    <FormControl
      size="small"
      className="select-dropdown"
      variant={variant}
      disabled={disabled}
      error={error}
    >
      <InputLabel>{label}</InputLabel>
      <MuiSelect
        value={value}
        onChange={onChange}
        sx={(theme) => selectStyles(theme)}
        name={name}
        onBlur={onBlur}
        label={label}
      >
        {options.map((option, i) => (
          <MenuItem key={i} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </MuiSelect>
      {error && helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
};

export default Select;
